import React, { Component } from 'react';
import { debounce, cloneDeep } from 'lodash';
import { Avatar, Button, Col, Form, Input, Modal, Row, Select, Table, Tooltip, InputNumber, message } from 'antd';
import { CalendarOutlined, DeleteOutlined } from '@ant-design/icons';
import DatePicker from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";
import { PriceFormat, SearchFormat } from '../scripts/helpers';
import { Constants } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class SpecialOfferForm extends Component {
    constructor() {
        super();

        this.state = {
            products: [],
            selected: []
        };

        this.formRef = React.createRef();
        this.boxRef = React.createRef();
        this.inputRef = React.createRef();

        this.handleSearch = debounce(this.handleSearch, 500);
    }

    handleDate = (date, obj) => {
        const state = {};
        state[obj] = date;
        this.formRef.current.setFieldsValue(state);
    };

    handleOffer = (value, record) => {
        const products = [...this.state.selected];
        const index = products.findIndex(o => o.id === record.id);
        const product = products[index];
        product.offer = value;
        products.splice(index, 1, product);
        this.setState({ selected: products });
    }

    handleFilter = (input, option) => {
        const value = SearchFormat(input);
        const split = value.split(' ');
        let valid = option.code.indexOf(value) >= 0;

        split.forEach(val => {
            valid = valid || option.name.indexOf(val) >= 0;
        });

        return valid;
    }

    handleCount = (value, record) => {
        const products = [...this.state.selected];
        const index = products.findIndex(o => o.id === record.id);
        const product = products[index];
        product.count = value;
        products.splice(index, 1, product);
        this.setState({ selected: products });
    }

    handleSelect = (value, clear) => {
        if (value) {
            const { products, selected } = this.state;
            const product = selected.find(o => o.id === value);

            if (product) {
                this.handleCount(product.count + 1, product);
            } else {
                const product = products.find(o => o.id === value);
                this.setState({ selected: [...selected, product] });
            }

            if (clear) {
                this.setState({ products: [] });
                this.boxRef.current.resetFields();
                this.inputRef.current.focus();
            }
        } else {
            this.setState({ products: [] });
        }
    }

    handleSearch = (value) => {
        if (value) {
            API.product.list({ q: SearchFormat(value) }).then((result) => {
                if (result.data && result.data.length) {
                    const products = result.data.map(o => {
                        return {
                            id: o.id,
                            name: o.name,
                            image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
                            code: o.code,
                            priceOne: parseInt(o.priceOne),
                            priceTwo: parseInt(o.priceTwo),
                            priceThree: parseInt(o.priceThree),
                            offer: parseInt(o.priceOne),
                            count: 1
                        }
                    });

                    this.setState({ products: products });

                    if (products.length === 1) {
                        setTimeout(() => {
                            this.handleSelect(products[0].id, true);
                        }, 0);
                    }
                } else {
                    this.setState({ products: [] });
                }
            });
        }
    }

    handleRemove = (id) => {
        const selected = [...this.state.selected];
        this.setState({ selected: selected.filter(o => o.id !== id) });
    }

    handleSubmit = () => {
        this.formRef.current.validateFields()
            .then(values => {
                if (this.state.selected.length > 8) {
                    const { selected } = this.state;
                    const { endDate, startDate } = values;

                    values.endDate = moment(`${endDate.year}-${endDate.month}-${endDate.day}`, Constants.jDateFormat).format(Constants.dateFormat);
                    values.startDate = moment(`${startDate.year}-${startDate.month}-${startDate.day}`, Constants.jDateFormat).format(Constants.dateFormat);
                    values.products = selected.map(o => { return { product_id: o.id, offer: o.offer, count: o.count } });

                    this.props.onSubmit(values);
                } else {
                    message.warning(Resources.specialOffersWarning);
                }
            });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();
        this.boxRef.current.resetFields();
        this.setState({ products: [], selected: [] });
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);

        if (cloneData.id) {
            const startDate = moment(cloneData.startDate);
            const endDate = moment(cloneData.endDate);
            const products = cloneData.product.map(o => {
                return {
                    id: o.id,
                    name: o.name,
                    image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
                    code: o.code,
                    priceOne: parseInt(o.priceOne),
                    priceTwo: parseInt(o.priceTwo),
                    priceThree: parseInt(o.priceThree),
                    offer: parseInt(o.pivot.offer),
                    count: parseInt(o.pivot.count || 1)
                }
            });

            cloneData.endDate = { day: endDate.jDate(), month: endDate.jMonth() + 1, year: endDate.jYear() };
            cloneData.startDate = { day: startDate.jDate(), month: startDate.jMonth() + 1, year: startDate.jYear() };

            this.formRef.current.setFieldsValue(cloneData);
            this.setState({ editMode: true, selected: products });
        } else {
            this.setState({ editMode: false });
        }
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, products, selected } = this.state;

        const columns = [{
            title: Resources.title,
            dataIndex: 'name'
        }, {
            title: Resources.image,
            dataIndex: 'image',
            width: '50px',
            render: val => <Tooltip title={<Avatar src={`${Constants.imagePathProduct}${val}`} shape="square" size={200} />}><Avatar src={`${Constants.imagePathProduct}${val}`} shape="square" size="small" /></Tooltip>
        }, {
            title: Resources.barcode,
            dataIndex: 'code',
            className: 'col-center',
            width: '150px'
        }, {
            title: Resources.count,
            dataIndex: 'count',
            className: 'col-center',
            width: '80px',
            render: (val, record) => <InputNumber min={1} value={val} onChange={value => this.handleCount(value, record)} style={{ width: '100%' }} />
        }, {
            title: `${Resources.price} (${Resources.rial})`,
            dataIndex: 'priceOne',
            className: 'col-center',
            width: '120px',
            render: (val, record) => PriceFormat(`${val}/${record.priceTwo}/${record.priceThree}`)
        }, {
            title: `${Resources.price} ${Resources.new} (${Resources.rial})`,
            dataIndex: 'offer',
            className: 'col-center',
            width: '120px',
            render: (val, record) => <InputNumber min={0} defaultValue={val} onChange={value => this.handleOffer(value, record)} style={{ width: '100%' }} />
        }, {
            title: Resources.action,
            dataIndex: 'id',
            className: 'col-center',
            width: '80px',
            render: val => (
                <Tooltip title={Resources.delete}>
                    <Button type="link" icon={<DeleteOutlined />} onClick={() => this.handleRemove(val)} />
                </Tooltip>
            )
        }];

        const DatePickerInput = ({ ref }, name) => {
            const date = this.formRef.current ? this.formRef.current.getFieldValue(name) : null;
            return <Input value={date ? `${date.year}-${date.month}-${date.day}` : date} prefix={<CalendarOutlined />} placeholder={Resources.choose} ref={ref} readOnly />;
        };

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={1000}>
                <Form ref={this.boxRef}>
                    <Form.Item name="search">
                        <Select
                            allowClear
                            filterOption={(input, option) => this.handleFilter(input, option)}
                            onSearch={this.handleSearch}
                            onChange={val => this.handleSelect(val, false)}
                            placeholder={Resources.search}
                            ref={this.inputRef}
                            className="ant-select-xl"
                            showSearch>
                            {products.map(o => <Select.Option key={o.id} value={o.id} name={o.name} code={o.code}>{o.name}</Select.Option>)}
                        </Select>
                    </Form.Item>
                </Form>
                <Table
                    columns={columns}
                    dataSource={selected}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    style={{ marginBottom: 16 }}
                />
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} md={12}>
                            <Form.Item name="startDate" label={Resources.startDate} rules={Rules.required}>
                                <DatePicker
                                    locale="fa"
                                    onChange={value => this.handleDate(value, 'startDate')}
                                    renderInput={(ref) => DatePickerInput(ref, 'startDate')}
                                    shouldHighlightWeekends
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item name="endDate" label={Resources.endDate} rules={Rules.required}>
                                <DatePicker
                                    locale="fa"
                                    onChange={value => this.handleDate(value, 'endDate')}
                                    renderInput={(ref) => DatePickerInput(ref, 'endDate')}
                                    shouldHighlightWeekends
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default SpecialOfferForm;